const frameOptions = [
  {
    id: 'ANTHRACITE - PRIME FLOAT (60MTRS/BOX) 35w x 55h x 25rw for Canvas A102601',
    name: 'ANTHRACITE - PRIME FLOAT (60MTRS/BOX) 35w x 55h x 25rw for Canvas A102601',
    thickness: 25,
    width: 35,
    height: 55,
    price: 22.2,
    img: '/assets/CanvasPrint&Frame/ANTHRACITE - PRIME FLOAT (60MTRS BOX) 35w x 55h x 25rw for Canvas A102601.jpg'
  },
  {
    id: 'TOBACCO - PRIME FLOAT (60MTRS/BOX) 35w x 55h x 25rw for Canvas A102602',
    name: 'TOBACCO - PRIME FLOAT (60MTRS/BOX) 35w x 55h x 25rw for Canvas A102602',
    thickness: 25,
    width: 35,
    height: 55,
    price: 22.2,
    img: '/assets/CanvasPrint&Frame/TOBACCO - PRIME FLOAT (60MTRS BOX) 35w x 55h x 25rw for Canvas A102602.jpg'
  },
  {
    id: 'NATURAL - PRIME FLOAT (60MTRS/BOX) 35w x 45h x 25rw for Canvas A102603',
    name: 'NATURAL - PRIME FLOAT (60MTRS/BOX) 35w x 45h x 25rw for Canvas A102603',
    thickness: 25,
    width: 35,
    height: 45,
    price: 22.2,
    img: '/assets/CanvasPrint&Frame/NATURAL - PRIME FLOAT (60MTRS BOX) 35w x 45h x 25rw for Canvas A102603.jpg'
  },
  {
    id: 'WHITE WASH - PRIME FLOAT (60MTRS/BOX) 35w x 55h x 25rw for Canvas A102604',
    name: 'WHITE WASH - PRIME FLOAT (60MTRS/BOX) 35w x 55h x 25rw for Canvas A102604',
    thickness: 25,
    width: 35,
    height: 55,
    price: 22.2,
    img: '/assets/CanvasPrint&Frame/WHITE WASH - PRIME FLOAT (60MTRS BOX) 35w x 55h x 25rw for Canvas A102604.jpg'
  },
  {
    id: 'BLACK - PRIME FLOAT (60MTRS/BOX) 35w x 55h x 25rw for Canvas A102605',
    name: 'BLACK - PRIME FLOAT (60MTRS/BOX) 35w x 55h x 25rw for Canvas A102605',
    thickness: 25,
    width: 35,
    height: 55,
    price: 22.2,
    img: '/assets/CanvasPrint&Frame/BLACK - PRIME FLOAT (60MTRS BOX) 35w x 55h x 25rw for Canvas A102605.jpg'
  },
  {
    id: 'WHITE - PRIME FLOAT (60MTRS/BOX) 35w x 55h x 25rw for Canvas A102606',
    name: 'WHITE - PRIME FLOAT (60MTRS/BOX) 35w x 55h x 25rw for Canvas A102606',
    thickness: 25,
    width: 35,
    height: 55,
    price: 22.2,
    img: '/assets/CanvasPrint&Frame/WHITE - PRIME FLOAT (60MTRS BOX) 35w x 55h x 25rw for Canvas A102606.jpg'
  },
  {
    id: 'TEAK - PRIME FLOAT (60MTRS/BOX) 35w x 55h x 25rw for Canvas A102607',
    name: 'TEAK - PRIME FLOAT (60MTRS/BOX) 35w x 55h x 25rw for Canvas A102607',
    thickness: 25,
    width: 35,
    height: 55,
    price: 22.2,
    img: '/assets/CanvasPrint&Frame/TEAK - PRIME FLOAT (60MTRS BOX) 35w x 55h x 25rw for Canvas A102607.jpg'
  },
  {
    id: 'Float Gold - Romeo (70M/Box) 34w x 45h x 23rw for Canvas A166007',
    name: 'Float Gold - Romeo (70M/Box) 34w x 45h x 23rw for Canvas A166007',
    thickness: 23,
    width: 34,
    height: 45,
    price: 20.95,
    img: '/assets/CanvasPrint&Frame/Float Gold - Romeo (70M Box) 34w x 45h x 23rw for Canvas A166007.jpg'
  },
  {
    id: 'Float Silver - Romeo (70M/Box) 34w x 45h x 23rw for Canvas A166008',
    name: 'Float Silver - Romeo (70M/Box) 34w x 45h x 23rw for Canvas A166008',
    thickness: 23,
    width: 34,
    height: 45,
    price: 20.95,
    img: '/assets/CanvasPrint&Frame/Float Silver - Romeo (70M Box) 34w x 45h x 23rw for Canvas A166008.jpg'
  },
  {
    id: 'FLOAT CHARCOAL - VINTAGE (40M/BOX) 37w x 50h x 26rw for Canvas A203101',
    name: 'FLOAT CHARCOAL - VINTAGE (40M/BOX) 37w x 50h x 26rw for Canvas A203101',
    thickness: 26,
    width: 37,
    height: 50,
    price: 17.65,
    img: '/assets/CanvasPrint&Frame/FLOAT CHARCOAL - VINTAGE (40M BOX) 37w x 50h x 26rw for Canvas A203101.jpg'
  },
  {
    id: 'FLOAT COCOA - VINTAGE (40M/BOX) 37w x 50h x 26rw for Canvas A203102',
    name: 'FLOAT COCOA - VINTAGE (40M/BOX) 37w x 50h x 26rw for Canvas A203102',
    thickness: 26,
    width: 37,
    height: 50,
    price: 16.65,
    img: '/assets/CanvasPrint&Frame/FLOAT COCOA - VINTAGE (40M BOX) 37w x 50h x 26rw for Canvas A203102.jpg'
  },
  {
    id: 'FLOAT COCONUT - VINTAGE (40M/BOX) 37w x 50h x 26rw for Canvas A203103',
    name: 'FLOAT COCONUT - VINTAGE (40M/BOX) 37w x 50h x 26rw for Canvas A203103',
    thickness: 26,
    width: 37,
    height: 50,
    price: 17.65,
    img: '/assets/CanvasPrint&Frame/FLOAT COCONUT - VINTAGE (40M BOX) 37w x 50h x 26rw for Canvas A203103.jpg'
  },
  {
    id: 'Bamboo - Float Gold (34M/Box) 37w x 50h x 26rw for Canvas A212201',
    name: 'Bamboo - Float Gold (34M/Box) 37w x 50h x 26rw for Canvas A212201',
    thickness: 26,
    width: 37,
    height: 50,
    price: 24.5,
    img: '/assets/CanvasPrint&Frame/Bamboo - Float Gold (34M Box) 37w x 50h x 26rw for Canvas A212201.jpg'
  },
  {
    id: 'Bamboo - Float Silver (34M/Box) 45w x 55h x 28rw for Canvas A212202',
    name: 'Bamboo - Float Silver (34M/Box) 45w x 55h x 28rw for Canvas A212202',
    thickness: 28,
    width: 45,
    height: 55,
    price: 24.5,
    img: '/assets/CanvasPrint&Frame/Bamboo - Float Silver (34M Box) 45w x 55h x 28rw for Canvas A212202.jpg'
  },
  {
    id: 'GOLD - BAROCCO FLOAT (48M/BOX) 42w x 54h x 29rw for Canvas A90102',
    name: 'GOLD - BAROCCO FLOAT (48M/BOX) 42w x 54h x 29rw for Canvas A90102',
    thickness: 29,
    width: 42,
    height: 54,
    price: 22.95,
    img: '/assets/CanvasPrint&Frame/GOLD - BAROCCO FLOAT (48M BOX) 42w x 54h x 29rw for Canvas A90102.jpg'
  },
  {
    id: 'SILVER - BAROCCO FLOAT (48M/BOX) 42w x 54h x 29rw for Canvas A90103',
    name: 'SILVER - BAROCCO FLOAT (48M/BOX) 42w x 54h x 29rw for Canvas A90103',
    thickness: 29,
    width: 42,
    height: 54,
    price: 22.95,
    img: '/assets/CanvasPrint&Frame/SILVER - BAROCCO FLOAT (48M BOX) 42w x 54h x 29rw for Canvas A90103.jpg'
  },
  {
    id: 'SILVER /BLACK - BAROCCO FLOAT (48M/BOX) 42w x 54h x 29rw for Canvas A90104',
    name: 'SILVER /BLACK - BAROCCO FLOAT (48M/BOX) 42w x 54h x 29rw for Canvas A90104',
    thickness: 29,
    width: 42,
    height: 54,
    price: 22.95,
    img: '/assets/CanvasPrint&Frame/SILVER - BLACK - BAROCCO FLOAT (48M BOX) 42w x 54h x 29rw for Canvas A90104.jpg'
  },
  {
    id: 'SILVER /WHITE - BAROCCO FLOAT (48M/BOX) 42w x 54h x 29rw for Canvas A90105',
    name: 'SILVER /WHITE - BAROCCO FLOAT (48M/BOX) 42w x 54h x 29rw for Canvas A90105',
    thickness: 29,
    width: 42,
    height: 54,
    price: 22.95,
    img: '/assets/CanvasPrint&Frame/SILVER - WHITE - BAROCCO FLOAT (48M BOX) 42w x 54h x 29rw for Canvas A90105.jpg'
  },
  {
    id: 'Float - Natural Real Veneer (64M/Box) 35w x 55h x 26rw for Canvas AR24BWRV',
    name: 'Float - Natural Real Veneer (64M/Box) 35w x 55h x 26rw for Canvas AR24BWRV',
    thickness: 26,
    width: 35,
    height: 55,
    price: 24.95,
    img: '/assets/CanvasPrint&Frame/Float - Natural Real Veneer (64M Box) 35w x 55h x 26rw for Canvas AR24BWRV.jpg'
  },
  {
    id: 'Float - Natural Real Veneer (64M/Box) 35w x 55h x 26rw for Canvas AR24OAKRV',
    name: 'Float - Natural Real Veneer (64M/Box) 35w x 55h x 26rw for Canvas AR24OAKRV',
    thickness: 26,
    width: 35,
    height: 55,
    price: 24.95,
    img: '/assets/CanvasPrint&Frame/Float - Natural Real Veneer (64M Box) 35w x 55h x 26rw for Canvas AR24OAKRV.jpg'
  },
  {
    id: 'Natural Oak - Float Raw  (54M/Box) 34w x 45h x 35rw for Canvas AR661OAKC',
    name: 'Natural Oak - Float Raw  (54M/Box) 34w x 45h x 35rw for Canvas AR661OAKC',
    thickness: 35,
    width: 34,
    height: 45,
    price: 18.55,
    img: '/assets/CanvasPrint&Frame/Natural Oak - Float Raw  (54M Box) 34w x 45h x 35rw for Canvas AR661OAKC.jpg'
  },
];

export default frameOptions;